import { Box, Button, ButtonGroup, Modal, Stack } from '@mui/material'
import DynamicForm from '../DynamicForm/DynamicForm'

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '95vw',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  textAlign: 'center',
  bgcolor: 'background.paper',
  borderRadius: 4,
  boxShadow: 24,
  p: 2,
}

const FormDefinitionDialog = ({
  readOnly,
  onEdit,
  formDefinition,
  isEditingMode,
  open,
  saveFormData,
  handleClose,
  data,
  children,
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <DynamicForm
          data={data}
          formDefinition={formDefinition}
          handleClose={handleClose}
          readOnly={readOnly}
          saveFormData={saveFormData}
        >
          {children}
          <Stack direction="column" display="flex" position="sticky" pt={2} spacing={1}>
            {/* Distinct keys stop React from reusing Editar's DOM node as the submit button: the
                swap happens before the browser runs the click's default action, which would submit. */}
            {readOnly ? (
              <ButtonGroup key="view" fullWidth>
                {onEdit && (
                  <Button size="small" variant="contained" onClick={onEdit}>
                    Editar
                  </Button>
                )}
                <Button size="small" variant="outlined" onClick={() => handleClose()}>
                  Cerrar
                </Button>
              </ButtonGroup>
            ) : (
              <ButtonGroup key="edit" fullWidth>
                <Button disabled={isEditingMode} size="small" type="submit" variant="contained">
                  GUARDAR
                </Button>
                <Button size="small" variant="outlined" onClick={() => handleClose()}>
                  Cancelar
                </Button>
              </ButtonGroup>
            )}
          </Stack>
        </DynamicForm>
      </Box>
    </Modal>
  )
}

export default FormDefinitionDialog
